import React from "react";
import { Award } from "lucide-react";

/**
 * AdvisorRecommendationBadge — reusable across Design Studio modules
 * (Flights first; Hotels, Experiences, Dining later). Quiet gold pill.
 */
export function AdvisorRecommendationBadge({ label = "Advisor Recommendation", className = "", testId = "advisor-recommendation-badge" }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-[hsl(var(--accent-gold))]/40 bg-[hsl(var(--accent-gold))]/10 ${className}`}
      data-testid={testId}
    >
      <Award className="size-3 text-[hsl(var(--accent-gold))]" strokeWidth={1.5} />
      <span className="font-mono text-[9.5px] uppercase tracking-[0.2em] text-[hsl(var(--accent-gold))]">
        {label}
      </span>
    </span>
  );
}

export default AdvisorRecommendationBadge;
